import EVisitsWorkspaceSelector from './e-visits-workspace-switcher';

export default EVisitsWorkspaceSelector;
